/** Only root-relative destinations may receive a newly authenticated session. */
export function safeLoginRedirect(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(value)) {
    return '/';
  }

  try {
    const base = 'https://redirect.invalid';
    const url = new URL(value, base);
    // Dot-segment normalization can turn /a/..//host into //host. Never return
    // a network-path reference, including encoded separators for downstream routers.
    const path = decodeURIComponent(url.pathname);
    if (url.origin !== base || path.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(path)) {
      return '/';
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/';
  }
}
